import { useApi } from '@/api';
import { Page } from '@/components';
import {
  BlankNotepadIcon,
  Card,
  CryptoIcon,
  EmptyBox,
  Flex,
  Heading,
  KpiCard
} from '@blockanalitica/ui';
import { useParams } from 'react-router';
import CollateralAssetHistoricBarChart from './CollateralAssetHistoricBarChart';
import CollateralAssetBreakdown from './CollateralAssetBreakdown';
import { DEFAULT_NETWORK } from '@/constants';

type Collateral = {
  date: string;
  underlying_address: string;
  underlying_symbol: string;
  underlying_name: string | null;
  total_debt: string | null;
  total_debt_change: string | null;
  total_debt_change_percentage: string | null;
  emode: boolean;
};

export default function CollateralPage() {
  const { marketAddress } = useParams() as {
    marketAddress: string;
  };
  const network = DEFAULT_NETWORK;

  const [data, error] = useApi<Collateral>({
    url: `/markets/${marketAddress}/collateral/`
  });

  if (error) throw error;

  if (!data || Object.keys(data).length === 0) {
    return (
      <EmptyBox
        icon={<BlankNotepadIcon />}
        message={`This collateral asset is not backing any debt`}
      />
    );
  }
  const title = (
    <Flex gap="xs">
      <CryptoIcon
        name={data.underlying_symbol}
        address={marketAddress}
        network={network}
        size="5"
      />
      <Heading size="0">Collateral Backing Debt</Heading>
    </Flex>
  );

  return (
    <Page title={title}>
      <KpiCard
        title={`Total debt backed by ${data.underlying_symbol} `}
        data={data}
        field="total_debt"
        options={{
          trend: true,
          variants: { valuePercentageValue: 'dynamic' },
          currency: 'USD'
        }}
      />

      <CollateralAssetBreakdown marketAddress={marketAddress} />

      <Card>
        <CollateralAssetHistoricBarChart marketAddress={marketAddress} />
      </Card>
    </Page>
  );
}
